import { Box, Stack, Typography } from "@mui/material"
import { MobiliserStatusChip } from "routes/asset-register/plugins/asset-mapping/mobiliser-status-chip.js"
import { If } from "lib/@components/switch.js"
import { SettingsDialog } from "routes/asset-register/plugins/asset-mapping/settings-dialog.js"

export function MobiliserHeader({ status, showSettingsButton = false }) {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ pt: 1 }}>
            <Stack direction="row" alignItems="center" gap={1}>
                <Typography title variant="h6">
                    SFG20 Mobiliser
                </Typography>
                <MobiliserStatusChip status={status} />
            </Stack>
            <If value={showSettingsButton}>
                <SettingsDialog />
            </If>
        </Box>
    )
}
